// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1300":"6003ca90","5255":"6003ca90","6677":"6003ca90"}[chunkId] + ".chunk.css";
};